export default __webpack_public_path__ + "static/media/chapter1.c00d36f4.svg";